import { SIZE } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const StyledNoFoundPage = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  background: #0f425a;
  padding: 100px 0;

  img {
    @media (min-width: ${SIZE.mobile}) {
      height: 150px;
      width: 300px;
    }

    @media (min-width: ${SIZE.tablet}) {
      height: 250px;
      width: 500px;
    }

    @media (min-width: ${SIZE.desktop}) {
      height: auto;
      width: auto;
    }
  }

  .title {
    ${FONT_FAMILY.FontBold}
    ${FONTS.font36}
    text-transform: uppercase;
    color: ${COLORS.red};
    margin-bottom: 61px;

    @media (min-width: ${SIZE.mobile}) {
      ${FONTS.font36}
    }

    @media (min-width: ${SIZE.tablet}) {
      ${FONTS.font36}
    }

    @media (min-width: ${SIZE.desktop}) {
      ${FONTS.font36}
    }
  }

  .notFound {
    ${FONTS.font36}
    text-transform: capitalize;
    color: ${COLORS.white};
    margin-top: 50px;

    @media (min-width: ${SIZE.mobile}) {
      ${FONTS.font28}
    }

    @media (min-width: ${SIZE.tablet}) {
      ${FONTS.font36}
    }

    @media (min-width: ${SIZE.desktop}) {
      ${FONTS.font36}
    }
  }
`;
